// extracted by mini-css-extract-plugin
module.exports = {"contMultiBtns":"styles_contMultiBtns__34R0d","contBtns":"styles_contBtns__3dNHm"};